const initAdvSdk = () => {
  if (window.adv) {
    const { getEnv, getChannelEnv, initAdv } = window.adv
    const env = getEnv()
    const channel = getChannelEnv()
    const isMX = window.location.hostname?.includes("didifinance") || false
    initAdv({
      env,
      channel,
      omega: window.Omega,
      bid: 'creditcard',
      loadHeatMap: true,
      cluster: isMX ? 'mx' : 'us',
      pageType: "h5cc"
    })
  }
}

export default initAdvSdk